var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C3.85775 15.5 0.5 12.1423 0.5 8C0.5 3.85775 3.85775 0.5 8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5ZM6.9665 5.31125C6.92136 5.28113 6.8689 5.26383 6.8147 5.26117C6.76051 5.25851 6.7066 5.2706 6.65873 5.29615C6.61086 5.3217 6.57082 5.35975 6.54287 5.40626C6.51492 5.45277 6.5001 5.50599 6.5 5.56025V10.4398C6.5001 10.494 6.51492 10.5472 6.54287 10.5937C6.57082 10.6402 6.61086 10.6783 6.65873 10.7039C6.7066 10.7294 6.76051 10.7415 6.8147 10.7388C6.8689 10.7362 6.92136 10.7189 6.9665 10.6888L10.6258 8.24975C10.6669 8.22236 10.7006 8.18524 10.724 8.14166C10.7473 8.09809 10.7595 8.04943 10.7595 8C10.7595 7.95057 10.7473 7.90191 10.724 7.85834C10.7006 7.81476 10.6669 7.77764 10.6258 7.75025L6.96575 5.31125H6.9665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.90a050137239c3c45c92d222392213e4.svg";
export { ForwardRef as ReactComponent };